import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IRecommend {
    rank?: number
    user?: {
        id: string
        name: string
        thumbnail: string
    }
    id: string
    user_id?: string
    title?: string
    'content?'?: string
    category?: string
    images?: string[]
    likes_count?: number
    comments_count?: number
    created_at: number
    visibility?: number
    guild_id?: string
    language?: string
    channel?: string
}

export const getRecommend = async (size: number, current_page: number = 1): Promise<ApiRes<IRecommend[]>> => {
    return await apiGet(API_URL, `admin/post/featured?page_size=${size}&current_page=${current_page}`)
}
